import { useHelpers } from 'context';

export const TouchscreenHelper = () => {
    useHelpers('mobileTouchscreen');
    return null;
};
